import React, { useState } from "react";
import { Table, Input, Select, Modal, Row, Col } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import ManagerService from "../../services/ManagerService";

const { Option } = Select;

const BangBdSc = ({ data }) => {
  const [filters, setFilters] = useState({ loai: "", gia: "", trang_thai: "" });
  const [pageSize, setPageSize] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [ChiPhi, setCP] = useState(null);

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleOpenModal = async (record) => {
    try {
      const response = await ManagerService.Lay_CP_Bd_Sc(record.id);
      setCP(response?.data || []);
    } catch (error) {
      console.error("Lỗi khi tải chi phí:", error);
      setCP([]);
    }
    setSelectedRow(record);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
  };

  const filteredData = data.filter((item) => {
    return (
      (filters.loai ? item.loai === filters.loai : true) &&
      (filters.trang_thai ? item.trang_thai === filters.trang_thai : true) &&
      (filters.tong_cp ? item.tong_cp <= Number(filters.tong_cp) : true)
    );
  });

  const columns = [
    {
      title: "Mã đơn",
      dataIndex: "id",
      key: "id",
      width: 120,
      render: (text, record) => (
        <button 
          style={{ 
            background: "none", 
            border: "none", 
            color: "blue", 
            textDecoration: "underline", 
            cursor: "pointer" 
          }} 
          onClick={() => handleOpenModal(record)}
        >
          {text}
        </button>
      ),
    },
    { title: "Biển kiểm soát", dataIndex: "bien_kiem_soat", key: "bien_kiem_soat", width: 150 },
    { title: "Loại", dataIndex: "loai", key: "loai", width: 120 },
    { title: "Ghi chú", dataIndex: "ghi_chu", key: "ghi_chu", width: 200 },
    { title: "Tổng chi phí", dataIndex: "tong_cp", key: "tong_cp", width: 120 },
    { title: "Trạng thái", dataIndex: "trang_thai", key: "trang_thai", width: 150 },
    {
      title: null,
      dataIndex: "trang_thai_ket_thuc",
      key: "trang_thai_ket_thuc",
      align: "center",
      width: 50,
      render: (text) =>
        text === "Hoàn tất bảo dưỡng - sửa chữa" ? (
          <CheckCircleOutlined style={{ color: "green", fontSize: "18px" }} />
        ) : text === "Hủy bảo dưỡng - sửa chữa" ? (
          <CloseCircleOutlined style={{ color: "red", fontSize: "18px" }} />
        ) : null,
    },
  ];
  

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Select
          placeholder="Chọn loại"
          onChange={(value) => handleFilterChange("loai", value)}
          allowClear
          style={{ width: 150, marginRight: 8 }}
        >
          {[...new Set(data.map((item) => item.loai))].map((loai) => (
            <Option key={loai} value={loai}>
              {loai}
            </Option>
          ))}
        </Select>

        <Input
          type="number"
          placeholder="Nhập chi phí tối đa"
          onChange={(e) => handleFilterChange("tong_cp", e.target.value)}
          style={{ width: 150, marginRight: 8 }}
        />

        <Select
          placeholder="Chọn trạng thái"
          onChange={(value) => handleFilterChange("trang_thai", value)}
          allowClear
          style={{ width: 150 }}
        >
          {[...new Set(data.map((item) => item.trang_thai))].map((trang_thai) => (
            <Option key={trang_thai} value={trang_thai}>
              {trang_thai}
            </Option>
          ))}
        </Select>
      </div>

      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="id"
        pagination={{
          pageSize,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20", "50"],
          onShowSizeChange: (current, size) => setPageSize(size),
        }}
        scroll={{ x: "auto" }}
        bordered
      />

      {/* Detail Modal */}
      <Modal 
        title="Chi tiết đơn bảo dưỡng - sửa chữa" 
        open={isModalOpen} 
        onCancel={handleCloseModal} 
        footer={null}
        width={750}
      >
        {selectedRow && (
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <p><strong>Mã đơn:</strong> {selectedRow.id}</p>
            </Col>
            <Col span={12}>
              <p><strong>Biển kiểm soát:</strong> {selectedRow.bien_kiem_soat}</p>
            </Col>
            <Col span={12}>
              <p><strong>Ngày sửa chữa:</strong> {selectedRow.ngay_sua_chua}</p>
            </Col>
            <Col span={12}>
              <p><strong>Trạm:</strong> {selectedRow.ten_tram}</p>
            </Col>
            <Col span={12}>
              <p><strong>Loại:</strong> {selectedRow.loai}</p>
            </Col>
            <Col span={12}>
              <p><strong>Ghi chú:</strong> {selectedRow.ghi_chu}</p>
            </Col>
            <Col span={12}>
              <p><strong>Trạng thái:</strong> {selectedRow.trang_thai}</p>
            </Col>
            <Col span={12}>
              <p><strong>Trạng thái kết thúc:</strong> {selectedRow.trang_thai_ket_thuc}</p>
            </Col>
            <Col span={12}>
              <p><strong>Tài xế gửi xe:</strong> {selectedRow.tai_xe_gui}</p>
            </Col>
            <Col span={12}>
              <p><strong>Tài xế lấy xe:</strong> {selectedRow.tai_xe_lay}</p>
            </Col>
            <Col span={24}>
              <p><strong>Giá:</strong> {selectedRow.gia} VNĐ</p>
            </Col>
            <Col xs={24}>
              <p><strong>Chi phí phụ:</strong></p>
              {ChiPhi.length > 0 ? (
                <ul>
                  {ChiPhi.map((cp, index) => (
                    <li key={index}>
                      {cp.name}: {cp.gia ? `${cp.gia} VNĐ` : "N/A"}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Không có dữ liệu chi phí phụ.</p>
              )}
            </Col>
            <Col span={24}>
              <p><strong>Tổng chi phí:</strong> {selectedRow.tong_cp} VNĐ</p>
            </Col>
          </Row>
        )}
      </Modal>
    </div>
  );
};

export default BangBdSc;
